import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { NotificationForm } from "@modules/notifications/components";
import { useNotificationCreateForm } from "./controller";

export const CreateNotification = React.memo(() => {
  const { methods, onSubmit, isPending } = useNotificationCreateForm();

  return (
    <Create footerButtons={<></>}>
      <FormProvider {...methods}>
        <NotificationForm onSubmit={onSubmit} isSubmitting={isPending} />
      </FormProvider>
    </Create>
  );
});
